<template>
  <el-table :data="records">
    <el-table-column label="操作人" prop="user_name" align="left">
    </el-table-column>
    <el-table-column label="操作时间" prop="serial_number" align="left">
      <template slot-scope="scope">
        {{ $time(scope.row.created_at).format('YYYY-MM-DD HH:mm') }}
      </template>
    </el-table-column>
    <el-table-column label="操作IP" prop="ip" align="left"> </el-table-column>
    <el-table-column label="操作类型" align="left" prop="category_name">
    </el-table-column>
    <el-table-column
      label="操作内容"
      align="left"
      prop="content"
      min-width="250"
    >
      <template slot-scope="scope">
        <div
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          "
        >
          {{ scope.row.content }}
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    records: {
      type: Array,
      default: () => [],
    },
  },
}
</script>